import React from 'react'
import { SectionHeader } from '../../../../components/SectionHeader'
import { TaskEntry } from '../../../../components/TaskEntry'
import type { DragOverlayContentProps } from './DragOverlayContent.types'

export const DragOverlayContent: React.FC<DragOverlayContentProps> = ({
  activeSectionDragId,
  activeDragId,
  segments,
  tasks,
  sectionDragWidth,
  sectionDragOverlayOffset,
  dragCount,
  dragRotation,
}) => {
  const rotationStyle = dragRotation != null
    ? { '--drag-rotation': `${dragRotation}deg` } as React.CSSProperties
    : undefined
  // Section drag overlay — reuses multi-drag-overlay card styling
  if (activeSectionDragId) {
    const dragSegment = segments.find(s => s.section?.id === activeSectionDragId)
    if (!dragSegment?.section) return null
    const sectionTaskCount = dragSegment.taskCount

    const sectionHeader = (
      <SectionHeader
        id={dragSegment.section.id}
        title={dragSegment.section.title}
        taskCount={sectionTaskCount}
        collapsed={dragSegment.section.collapsed}
        dragOverlay
        onToggleCollapse={() => {}}
        onRename={() => {}}
        onDelete={() => {}}
      />
    )

    const overlayStyle: React.CSSProperties = {
      ...(sectionDragWidth ? { width: sectionDragWidth } : {}),
      marginTop: -sectionDragOverlayOffset,
      ...rotationStyle,
    }

    return (
      <div className="drag-overlay-lift multi-drag-overlay section-drag-overlay" style={overlayStyle}>
        <div className="multi-drag-overlay__stack">
          {sectionTaskCount >= 3 && <div className="multi-drag-overlay__card multi-drag-overlay__card--back-2" />}
          {sectionTaskCount >= 2 && <div className="multi-drag-overlay__card multi-drag-overlay__card--back-1" />}
          <div className="multi-drag-overlay__card multi-drag-overlay__card--front">
            {sectionHeader}
          </div>
        </div>
        {sectionTaskCount > 0 && <span className="multi-drag-overlay__badge">{sectionTaskCount}</span>}
      </div>
    )
  }

  // Task drag overlay
  if (activeDragId) {
    const task = tasks?.find(t => t.id === activeDragId)
    if (!task) return null
    const count = dragCount || 1
    const taskEntry = (
      <TaskEntry
        mode="collapsed"
        task={{ id: task.id, title: task.title, completed: task.status === 'completed' }}
        selected
        focused={false}
        onToggleComplete={() => {}}
        checkKind={undefined}
        checkVariant={undefined}
      />
    )

    if (count <= 1) {
      return <div className="drag-overlay-lift" style={rotationStyle}>{taskEntry}</div>
    }

    return (
      <div className="drag-overlay-lift multi-drag-overlay" style={rotationStyle}>
        <div className="multi-drag-overlay__stack">
          {count >= 3 && <div className="multi-drag-overlay__card multi-drag-overlay__card--back-2" />}
          {count >= 2 && <div className="multi-drag-overlay__card multi-drag-overlay__card--back-1" />}
          <div className="multi-drag-overlay__card multi-drag-overlay__card--front">
            {taskEntry}
          </div>
        </div>
        <span className="multi-drag-overlay__badge">{count}</span>
      </div>
    )
  }

  return null
}
